import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_EMAIL_INPUT_TYPE = 'postermywall-email-input';

export const POSTERMYWALL_EMAIL_INPUT: AddComponentTypeOptions = createBaseInputComponent({
  inputFieldType: POSTERMYWALL_EMAIL_INPUT_TYPE,
  inputName: 'email',
  dataMarkerAttribute: 'data-is-pmw-form-email-input',
  displayName: 'Email',
  placeholder: 'Enter your email here',
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-email-input') !== null,
  additionalAttributes: {required: 'true', type: 'email'},
});
